import React, { Component } from 'react';
import MediaQuery from 'react-responsive';
import MobileBook from './MobileIndex';
import DesktopBook from './DesktopIndex';
import SideBarContent from '../SideBar/SideBarContent';
import { Redirect } from 'react-router-dom';
import UberConnectModal from '../User/UberConnectModal';
import Button from '../../artzu-ui/src/Button';
import Modal from '../../artzu-ui/src/Modal';
import { m } from '../../utils';
import gql from 'graphql-tag';
import { withApollo } from 'react-apollo';

class NewBook extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showConsentModal: !this.props.via_consent
    };
  }

  viaConsentModal = () => (
    <Modal
      open={
        this.props.operatingCity === 'new_york' &&
        this.state.showConsentModal
      }>
      <div className="apply__uber--terms-modal">
        <div
          className="apply__uber--terms-modal-text"
          style={{ textAlign: 'left', fontSize: '11px' }}>
          {' '}
          By clicking “Accept” with no further action, you agree that the
          fees you owe to Autzu (including Booking Fees and additional fees
          as applicable) will be deducted from your Via Driver Partner
          earnings and paid directly to Autzu on your behalf (the Earnings
          Deduction). You may opt out of the Earnings Deduction by emailing
          info@autzu.com, in which case you will be required to pre-pay
          your Booking Fees and any additional applicable fees by credit
          card.
          <br />
          See Section 6 of the{' '}
          <a href="/terms#earnings" target="_blank">
            Autzu Terms & Conditions
          </a>{' '}
          for more information.{' '}
        </div>
        <div
          className="apply__uber--terms-modal-button"
          style={{
            display: 'flex',
            width: '100%',
            justifyContent: 'space-evenly'
          }}>
          <Button
            label="Contact Us"
            onClick={() => {
              let media = window.matchMedia('(max-width: 767px)');
              if (media.matches) {
                window.location.assign('tel:+18336928898');
              } else {
                window.location.assign('/contact');
              }
            }}
            color="#414141"
          />
          <Button label="Accept" onClick={() => this.viaConsent()} />
        </div>
      </div>
    </Modal>
  );

  viaConsent = () => {
    const mutationString = gql`
      mutation ViaDeductionConsent($consentTime: DateTime!) {
        viaDeductionConsent(consentTime: $consentTime) {
          consentReceived
        }
      }
    `;
    this.props.client
      .mutate({
        mutation: mutationString,
        variables: { consentTime: m() }
      })
      .then(res => {
        if (res.data.viaDeductionConsent.consentReceived === true) {
          this.setState({ showConsentModal: false });
          this.props.loadData();
        }
      });
  };

  render() {
    const {
      status,
      loggedIn,
      uber_token,
      account_name,
      uber_password,
      email,
      operatingCity,
      via_consent
    } = this.props;
    const uberURL = `${
      process.env.REACT_APP_API_URL
    }/users/auth/uber?email=${encodeURIComponent(email)}`;
    if (status === 'operating') {
      return (
        <div className="book-index container">
          {!uber_token && operatingCity === 'toronto' ? (
            <UberConnectModal
              uberURL={uberURL}
              username={account_name}
              password={uber_password}
            />
          ) : null}
          {this.viaConsentModal()}
          <MediaQuery minWidth={768}>
            <div className="desktop-subheader">Book</div>
            <div className="sidebar-container">
              <SideBarContent status={status} signedIn={loggedIn} />
            </div>
            <DesktopBook />
          </MediaQuery>
          <MediaQuery maxWidth={767}>
            <MobileBook />
          </MediaQuery>
        </div>
      );
    } else {
      return <Redirect to="/" />;
    }
  }
}

export default withApollo(NewBook);



// WEBPACK FOOTER //
// ./src/components/NewBook/index.js